import { ApiService } from "../../../services/ApiService";
import {
  GET_ALL_MUCH_AND_LEARN,
  GET_ALL_THEME_OF_THE_WEEK,
  SESSION_EXPIRED,
} from "../../actionTypes";

export class muchAndLearnMngtThunk {
  static sessonExpred(sessionEx) {
    return async (dispatch) => {
      try {
        dispatch({
          type: SESSION_EXPIRED,
          payload: sessionEx,
        });
      } catch (err) {}
    };
  }

  static getAllMuchAndLearn() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(
          "trainings/munch-and-learn/get-all"
        );
        if (response.data) {
          dispatch({
            type: GET_ALL_MUCH_AND_LEARN,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getAllThemeOfTheWeek() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(
          "trainings/theme-of-the-week/get-all"
        );
        if (response.data) {
          dispatch({
            type: GET_ALL_THEME_OF_THE_WEEK,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/trainingmanagement/training.thunk.js